<template>
  <div>
    <v-container class="pb-0">
      <v-flex xs12 class="default-input">
        <v-text-field
          name="search"
          single-line
          :placeholder="$t('Search')"
          id="search"
          v-model="keyword"
          outline
          clearable
          prepend-inner-icon="search"
          hide-details
          @blur="getLineNotifyConnectList"
          @keydown.enter="getLineNotifyConnectList"
        ></v-text-field>
      </v-flex>
    </v-container>
    <v-container v-if="!loading">
      <CardLineNotify
        v-for="(item, index) in listing"
        :key="index"
        :item="item"
        @connectLineNotifyApprover="handleConnectLineNotify"
        @deleteApprover="handleDeleteApprover"
      ></CardLineNotify>
      <!-- @changeActive="handleChangeActive"
      @editSop="handleEditSop"
      @duplicateSop="handleDuplicateSop"
      @deleteSop="onDeleteSop" -->
    </v-container>
    <v-layout class="mt-5" row wrap v-else justify-center align-content-center>
      <v-progress-circular
        indeterminate
        color="primary"
        :size="100"
        :width="8"
      ></v-progress-circular>
    </v-layout>
  </div>
</template>

<script>
import yasaleAcApi from '@/api/yasale-ac'
import { mapGetters } from 'vuex'
import CardLineNotify from './CardLineNotify.vue'

export default {
  components: {
    CardLineNotify
  },
  data() {
    return {
      loading: false,
      listing: [],
      keyword: ''
    }
  },
  mounted() {
    this.getLineNotifyConnectList()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    activeAdminid() {
      if (
        this.$store.state.privilege &&
        this.$store.state.privilege.role &&
        this.$store.state.privilege.role === 'superadmin'
      ) {
        return null
      } else {
        return this.$store.state.userid
      }
    }
  },
  methods: {
    async getLineNotifyConnectList() {
      const vm = this
      try {
        let data = {
          page_id: vm.selectedBot.pageid,
          keyword: vm.keyword
        }
        if (this.activeAdminid) {
          data.admin_id = this.activeAdminid
        }

        vm.loading = true
        const response = await yasaleAcApi.getLineNotifyConnectList({
          config: {
            params: data
          }
        })

        vm.loading = false
        if (response && response.status === 200) {
          this.listing = response.data.data
          vm.orderOwn()
        }
      } catch (error) {
        vm.loading = false
        console.error(error)
        return
      }
    },
    orderOwn() {
      const vm = this
      if (!vm.activeAdminid) {
        let currentAdmin = null
        let etc = []
        vm.listing.forEach((item) => {
          if (item.adminid == vm.$store.state.userid) {
            currentAdmin = item
          } else {
            etc.push(item)
          }
        })
        vm.listing = [currentAdmin, ...etc]
      }
    },
    handleConnectLineNotify() {
      const link =
        'https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=k7ge3bjC0u4OMKFoh5wxQl&redirect_uri=' +
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '') +
        '/linenotify&scope=notify&state=zwizai'
      window.open(link, '_self')
    },
    handleDeleteApprover(adminId) {
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.DeleteLineNotifyApprover(adminId)
          }
        })
    },
    async DeleteLineNotifyApprover(adminId) {
      const vm = this
      try {
        let params = {
          pageid: vm.selectedBot.pageid,
          adminid: adminId
        }
        vm.loading = true
        const response = await yasaleAcApi.deleteLineNotify({ params })
        vm.loading = false
        if (response && response.status === 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.getLineNotifyConnectList()
        }
      } catch (error) {
        console.error(error)
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/ConnectLineApprover.vue